// Generated by purs version 0.14.1
"use strict";
var TypeEquals = function (Coercible0, proof) {
    this.Coercible0 = Coercible0;
    this.proof = proof;
};
var To = function (x) {
    return x;
};
var From = function (x) {
    return x;
};
var refl = new TypeEquals(function () {
    return undefined;
}, function (a) {
    return a;
});
var proof = function (dict) {
    return dict.proof;
};
var to = function (dictTypeEquals) {
    var v = proof(dictTypeEquals)(function (a) {
        return a;
    });
    return v;
};
var from = function (dictTypeEquals) {
    var v = proof(dictTypeEquals)(function (a) {
        return a;
    });
    return v;
};
module.exports = {
    TypeEquals: TypeEquals,
    proof: proof,
    to: to,
    from: from,
    refl: refl
};
